<template>
    <v-app id="app">
        <p>
            <!--      <router-link to="/">หน้าแรก</router-link>-->
            <!--      <router-link to="/Card1">Go to Bar</router-link>-->
        </p>
        <router-view></router-view>
    </v-app>
</template>

<script>
    // import Home from './components/Home.vue'

    export default {
        name: 'app',
        components: {
            // Home
        },
        computed: {},
        method: {}
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Prompt&display=swap');

    #app {
        font-family: 'Prompt', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    .swal2-popup {
        font-size: 1.6rem !important;
    }
</style>
